module.exports = __webpack_public_path__ + "static/media/sablier.a455d5e8.png";